import * as config from "Config";
import * as constants from "./constants";


export function clearStore(newObject) {
    return {
      type: constants.OPERATOR_PHONE_LIST_CLEAR_STORE
    };
}

export function initListData(params) {
    return {
      remote:{
          method: "get",
          url: config.apiUrl + "/api/OperatorPhone/Company/"+params.companyId + "/Summury"
      },
      actions: [
          constants.OPERATOR_PHONE_LIST_SUMMURY_LOAD_START,
          constants.OPERATOR_PHONE_LIST_SUMMURY_LOAD_SUCCESS,
          constants.OPERATOR_PHONE_LIST_SUMMURY_LOAD_FAIL,
      ]
    };
}

export function deleteOperatorPhone(params) {
    return {
      remote:{
          method: "delete",
          url: config.apiUrl + "/api/OperatorPhone/"+params.id + "/Company/" + params.companyId
      },
      actions: [
          constants.OPERATOR_PHONE_LIST_REMOVE_START,
          constants.OPERATOR_PHONE_LIST_REMOVE_SUCCESS,
          constants.OPERATOR_PHONE_LIST_REMOVE_FAIL,
      ]
    };
}

export function resetTokenOperatorPhone(params) {
    return {
      remote:{
          method: "post",
          url: config.apiUrl + "/api/OperatorPhone/"+params.id + "/Company/" + params.companyId+"/ResetToken"
      },
      actions: [
          constants.OPERATOR_PHONE_LIST_RESET_TOKEN_START,
          constants.OPERATOR_PHONE_LIST_RESET_TOKEN_SUCCESS,
          constants.OPERATOR_PHONE_LIST_RESET_TOKEN_FAIL,
      ]
    };
}
